var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        title: _vm.file.categoria
          ? "Responder Expediente " + _vm.file.categoria + "-" + _vm.file.numero
          : "Responder Expediente " + _vm.file.numero,
        "hide-footer": "",
        centered: ""
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c(
        "form",
        {
          attrs: { autocomplete: "off", "data-vv-scope": "answerForm" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              $event.preventDefault()
            }
          }
        },
        [
          _c("div", { staticClass: "mt-3" }, [
            _c("div", { staticClass: "bg-alert p-3" }, [
              _vm._v(
                " Por favor selecciona el archivo con el que quieres responder "
              ),
              _c("strong", [
                _vm._v(
                  "esto será visible por la persona que te ha enviado el expendiente para luego procesar la respuesta"
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "row mt-6" },
              [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("UploadFile", {
                      attrs: {
                        permission: "*",
                        accept:
                          ".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc",
                        text: "Seleccionar respuesta",
                        "data-cy": "UploadFile",
                        "max-size-in-mb": 30,
                        "upload-to": "ed",
                        "button-class": {
                          "btn-block": true,
                          "mb-5": _vm.errors.has("step-3.mainFileName")
                        },
                        "container-class": "w-100"
                      },
                      model: {
                        value: _vm.mainFile,
                        callback: function($$v) {
                          _vm.mainFile = $$v
                        },
                        expression: "mainFile"
                      }
                    })
                  ],
                  1
                ),
                Object.keys(_vm.mainFile).length
                  ? _c("div", { staticClass: "col-12 mt-3 mb-4" }, [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column align-items-center"
                        },
                        [
                          _c("vs-icon", {
                            attrs: {
                              icon: "description",
                              size: "75px",
                              color: "primary"
                            }
                          }),
                          _c(
                            "strong",
                            { staticClass: "text-truncate w-100 text-center" },
                            [_vm._v(_vm._s(_vm.mainFile.name))]
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "col-md-12 mt-3" },
                  [
                    _c("UploadFile", {
                      attrs: {
                        "data-cy": "upload-attachment",
                        permission: "*",
                        text: "Seleccionar adjuntos",
                        accept:
                          ".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc",
                        "upload-to": "ed",
                        "max-size-in-mb": 30,
                        "button-class": "btn-block",
                        "container-class": "w-100"
                      },
                      on: {
                        input: function($event) {
                          return _vm.addAdditionalFile()
                        }
                      },
                      model: {
                        value: _vm.additionalFile,
                        callback: function($$v) {
                          _vm.additionalFile = $$v
                        },
                        expression: "additionalFile"
                      }
                    })
                  ],
                  1
                ),
                _vm._l(_vm.additionalFiles, function(file) {
                  return _c(
                    "div",
                    { key: file.id, staticClass: "col-3 mt-3 mb-3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex flex-column align-items-center"
                        },
                        [
                          _c("vs-icon", {
                            attrs: {
                              icon: "description",
                              size: "75px",
                              color: "primary"
                            }
                          }),
                          _c(
                            "b",
                            { staticClass: "text-truncate w-100 text-center" },
                            [_vm._v(_vm._s(file.name))]
                          ),
                          file.type !== "respuesta"
                            ? _c("vs-button", {
                                attrs: {
                                  color: "danger",
                                  type: "flat",
                                  icon: "clear"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.removeAdditionalFile(file.id)
                                  }
                                }
                              })
                            : _vm._e(),
                          file.type === "respuesta"
                            ? _c(
                                "b-badge",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    "data-cy": "response",
                                    variant: "light-info"
                                  }
                                },
                                [_vm._v(" respuesta ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _c("div", { staticClass: "m-top-20" }, [
            _vm.warningMessage && !this.mainFile.name
              ? _c(
                  "div",
                  {
                    staticClass: "text-danger text-caption d-block text-center"
                  },
                  [_vm._v(" Archivo de respuesta requerido ")]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "text-right mt-3" },
              [
                _c(
                  "vs-button",
                  {
                    attrs: {
                      "data-cy": "Cancel",
                      color: "dark",
                      type: "border"
                    },
                    on: {
                      click: function($event) {
                        return _vm.cancelAsign()
                      }
                    }
                  },
                  [_vm._v(" Cancelar ")]
                ),
                _c(
                  "vs-button",
                  {
                    staticStyle: { "margin-left": "12px" },
                    attrs: {
                      "data-cy": "send-reply",
                      color: "primary",
                      type: "border"
                    },
                    on: {
                      click: function($event) {
                        return _vm.returnFile()
                      }
                    }
                  },
                  [_vm._v(" Enviar respuesta ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }